import React, { Component } from 'react';

import './login.css';
import FormLogin from '../../components/comLogin/formLogin';

class Login extends Component {

    render(){
        return(
            <div className='contenedorLogin container row'>
                <FormLogin />
            </div>
        );
    }
}

export default Login;